import { Autoplay, Navigation, Pagination, Keyboard, EffectFade, Mousewheel } from "swiper";


export const cardSliderColumnOptions = {
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  slidesPerView: 1,
  spaceBetween: 90,
  grabCursor: true,
  autoplay: false,
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 6,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 90,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 90,
    },

  },
}
